import { render, staticRenderFns } from "./CustomerInvoices.vue?vue&type=template&id=22f97894&scoped=true"
import script from "./CustomerInvoices.vue?vue&type=script&lang=js"
export * from "./CustomerInvoices.vue?vue&type=script&lang=js"
import style0 from "./CustomerInvoices.vue?vue&type=style&index=0&id=22f97894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f97894",
  null
  
)

export default component.exports